// extracted by mini-css-extract-plugin
export default {"card":"DeleteProductCard_card__pFUSZ","card1":"DeleteProductCard_card1__KGG7S"};